// Library imports
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

// Style imports
import FooterStyles from './Footer.module.scss';

/**
 * Footer: Footer Component
 * @returns
 */
export default function Footer() {
  return (
    <footer>
      <Container fluid className={`border-top ${FooterStyles.footerContainer}`}>
        <Row className="justify-content-center">
          <Col>
            <p className={FooterStyles.p}>
              © Incorta, Inc. All Rights Reserved.
            </p>
          </Col>
          <Col>
            <a
              href="https://www.incorta.com/privacy"
              style={{ color: '#393e41' }}
            >
              Privacy Policy
            </a>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}
